import { mobileDevice } from '@bingads-webui-campaign-react/mca-core';

export const getCardStepLayoutStyles = (_, { palette = {} }) => ({
  stepLayoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: palette.neutralLighterAlt,
    overflow: 'auto',
    height: '100%',
    width: '100%',
  },
  stepLayoutContentContainer: {
    padding: 40,
    [mobileDevice]: {
      padding: '30px 0 0',
      width: 350,
    },
  },
  stepLayoutHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  stepContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .step-footer': {
      padding: 0,
      border: 'none',
      marginTop: 32,
    },
  },
  stepLayoutFooterContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [mobileDevice]: {
      marginBottom: 30,
    },
  },
});
